<div class="base-container">
  @if (!isLoading()) {
    <nav mat-tab-nav-bar [tabPanel]="tabPanel">
      @for (link of navLinks; track $index) {
        <a
          mat-tab-link
          routerLink="{{ link.location }}"
          routerLinkActive
          #rla="routerLinkActive"
          [active]="rla.isActive">
          <fa-icon
            [icon]="['far', link.icon]"
            class="tab-icon"
            size="lg"></fa-icon>

          <span>{{ 'PRODUCT.WARNING.TABS.' + link.label | translate }}</span>
        </a>
      }
    </nav>
    <mat-tab-nav-panel #tabPanel>
      <router-outlet></router-outlet>
    </mat-tab-nav-panel>
  } @else {
    <app-loading-overlay text="Daten werden geladen..." [fullScreen]="false">
    </app-loading-overlay>
  }
</div>
